import { isNullOrEmpty } from '../utils';

export default {
  apiToken: window.localStorage.getItem('apiToken') || window.sessionStorage.getItem('apiToken') || null,
  appUser: JSON.parse(window.localStorage.getItem('appUser')) || JSON.parse(window.sessionStorage.getItem('appUser')) || null,
  states: [],
  cities: [],
  citiesByState: [],
  appLoading: false,
  buttonLoading: false,
  users: [],
  snackbar: {
    show: false,
    message: '',
    timeout: 4000,
  },
  moneyMask: {
    locale: 'pt-BR',
    prefix: 'R$',
    suffix: '',
    precision: 2,
  },
  percentMask: {
    locale: 'pt-BR',
    prefix: '',
    suffix: '%',
    precision: 2,
  },
  dateDefaultOptions: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  },
  formRules: {
    requiredRule: [
      value => !isNullOrEmpty(value) || 'Campo obrigatório',
    ],
    CNPJRule: [
      value => (!!value && value.length === 18) || 'Documento inválido',
      value => !!value || 'Campo obrigatório',
    ],
    CPFRule: [
      value => (!!value && value.length === 14) || 'Documento inválido',
      value => !!value || 'Campo obrigatório',
    ],
    emailRule: [
      value => (value === undefined || value === '' || /.+@.+\..+/.test(value)) || 'Email inválido',
    ],
    emailRequiredRule: [
      value => (value === undefined || value === '' || /.+@.+\..+/.test(value)) || 'Email inválido',
      value => !!value || 'Campo obrigatório',
    ],
    phoneRule: [
      value => (value === undefined || value === '' || /\(\d{2,}\) \d{4,}-\d{4}/.test(value)) || 'Telefone inválido',
    ],
    phoneRequiredRule: [
      value => (value === undefined || value === '' || /\(\d{2,}\) \d{4,}-\d{4}/.test(value)) || 'Telefone inválido',
      value => !!value || 'Campo obrigatório',
    ],
    nullOrMoreThanZero: [
      value => (value === null || parseFloat(value) >= 1) || 'Valor inválido',
    ],
  },
  baseDatatableHeaders: [
    {
      text: 'Nome',
      value: 'name',
      align: 'left',
    },
    {
      text: 'Ações',
      value: 'actions',
      align: 'right',
      sortable: false,
    },
  ],
  systemTypes: {
    BASIC_SYSTEM: 1,
    TENANT_SYSTEM: 2,
  },
};
